import * as React from 'react'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Props as MainProps } from '../../UpdateReferral'
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'

type Props = Pick<MainProps, 'variant'>

export function NotAddedReferralPreview(props: Props) {
  const { variant } = props
  const theme = useTheme()
  return variant === 'classic' ? (
    <Box mt={2}>
      <Alert severity="info">
        <Typography variant="body1">Referral not added</Typography>
      </Alert>
    </Box>
  ) : (
    <Box mt={0}>
      <Card
        variant="outlined"
        sx={{
          backgroundColor: theme.palette.background.default,
          border: 'solid 1px #e0e0e0',
          padding: theme.spacing(1),
        }}
      >
        <Typography variant="subtitle2">Referral not added</Typography>
      </Card>
    </Box>
  )
}
